import { useParams } from 'react-router-dom';
import Layout from '../../layouts/user';
import BtcAccumulatorTradeEntry from '../../components/invest/btcAccumulatorTradeEntry';
import BtcAccumulatorStructuredCard from '../../components/invest/btcAccumulatorStructuredCard';

function Page() {
  const { sourceCurrency, targetCurrency } = useParams();
  const isTradeEntryMode = Boolean(sourceCurrency && targetCurrency);
  const plans = [
    {
      title: 'BTC Accumulator (Structured Product)',
      subtitle: '',
      sourceCurrency: 'usdc',
      targetCurrency: 'usdc',
      type: 'btc',
    },

    {
      title: 'ETH Accumulator (Structured Product)',
      subtitle: '',
      sourceCurrency: 'usdc',
      targetCurrency: 'usdc',
      type: 'eth',
    },
  ];

  return (
    <Layout menu="plans">
      <div className="nk-content-body">
        {isTradeEntryMode ? (
          <BtcAccumulatorTradeEntry />
        ) : (
          <>
            <div className="nk-block-head text-center">
              <h2 className="nk-block-title fw-normal">
                Accumulator (Structured Product)
              </h2>
              <div className="nk-block-des w-max-550px m-auto">
                <p>
                  <strong>Choose your preferred structured product.</strong>
                </p>
              </div>
            </div>
            <div className="nk-ivp-apps">
              <div className="nk-ivp-plans row g-gs scheme-container justify-center">
                {plans.map((plan, i) => (
                  <div className="col-md-6 col-lg-6" key={i}>
                    <BtcAccumulatorStructuredCard plan={plan} />
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}

export default Page;
